import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Beneficiary, GiftVoucher, GiftVoucherOptionType, InvoiceDetailType, Item, ProcessStatus } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';

@Component({
  selector: 'app-gift-voucher-details',
  templateUrl: './gift-voucher-details.component.html',
  styleUrls: ['./gift-voucher-details.component.scss']
})
export class GiftVoucherDetailsComponent extends BaseComponent  implements OnInit {

  public giftVoucher: Item;
  public showView: boolean;

  public isForMyself = false;
  public isForOthers = true;
  public beneficiary: Beneficiary = new Beneficiary();
  public doCheckout = false;

  modalRef: BsModalRef;

  config = {
      backdrop: true,
      ignoreBackdropClick: true,
  };

  ngOnInit() {
      if (this.app.storageService.getItem(AppConstants.GiftVoucherProcessStatus) === ProcessStatus.Checkout.toString()) {
          this.app.router.navigate([AppConstants.RouteCheckout]);
          return;
      }

      this.app.storageService.removeItem(AppConstants.GiftVoucherPendingTransactionHeader);
      this.app.pageTitle = 'Gift Voucher Details';
      this.baseTriggerChild.subscribe((event) => {
          this.app.spinner.hide();
          this.giftVoucher = JSON.parse(this.app.storageService.getItem(AppConstants.GiftVoucherSelectedVoucher));
          if (this.app.stringService.isEmpty(this.giftVoucher)) {
              this.showErrorMessage('Please select gift voucher.');
              this.app.router.navigate([AppConstants.RouteGiftVouchers]);
              return;
          }
          this.app.pageTitle = this.giftVoucher.name;
      });
      this.start();
      this.beneficiary.firstName = '';
      this.beneficiary.lastName = '';
  }

  updateScreen(isFromForMaySelf: boolean = false) {
      if (isFromForMaySelf) {
          if (this.isForMyself) {
              this.isForOthers = false;
          } else {
              this.isForOthers = true;
          }
      } else {
          if (this.isForOthers) {
              this.isForMyself = false;
          } else {
              this.isForMyself = true;
          }
      }
  }

  addToBasket(template: TemplateRef<any>, doCheckout: boolean = false) {
      this.doCheckout = doCheckout;

      if (this.isForOthers) {
          this.modalRef = this.app.modalService.show(template, this.config);
          this.giftVoucher.isForMySelf = false;
      } else {
          if (this.app.customer != null) {
              this.beneficiary.firstName = this.app.customer.firstName;
              this.beneficiary.lastName = this.app.customer.lastName;
          } else {
              this.beneficiary = new Beneficiary();
              this.beneficiary.firstName = '';
              this.beneficiary.lastName = '';
          }
          this.giftVoucher.isForMySelf = true;
          this.addToCart();
      }
  }

  cancel() {
      this.modalRef.hide();
  }

  continue() {
      if (this.app.stringService.isEmpty(this.beneficiary.firstName)) {
          this.showErrorMessage('Please enter beneficiary first name.');
          return;
      }
      if (this.app.stringService.isEmpty(this.beneficiary.lastName)) {
          this.showErrorMessage('Please enter beneficiary last name.');
          return;
      }
      this.modalRef.hide();
      this.addToCart();
  }

  addToCart() {
      if (this.app.basketItems == null) {
          this.app.basketItems = [];
      }
      const item: Item = new Item();

      item.giftVoucherOptionType = GiftVoucherOptionType.IsElectronic;
      item.description = this.giftVoucher.name;
      item.invoiceDetailType = InvoiceDetailType.GiftVoucher;
      
      item.giftVoucherReceiverCollectorName = this.beneficiary.firstName + ' ' + this.beneficiary.lastName;
      item.giftVoucherMessage = this.beneficiary.message;

      if(this.app.customer!=null)
      {
        item.giftVoucherFrom = this.app.customer.firstName + ' ' + this.app.customer.lastName;
        item.customerId = this.app.customer.customerId;
      }
      
      item.quantity = 1;
      item.fee = this.giftVoucher.fee;
      item.itemId = this.giftVoucher.giftVoucherId;

      this.app.basketItems.push(item);

      this.app.storageService.setItem(AppConstants.GiftVoucherSelectedVouchers, JSON.stringify(this.app.basketItems));
      this.showSuccessMessage('Gift voucher successfully added to basket.');
      this.beneficiary = new Beneficiary();

      if (this.doCheckout) {
          this.app.router.navigate([AppConstants.RouteCheckout]);
      }
  }

  back() {
      this.app.router.navigate([AppConstants.RouteGiftVouchers]);
  }

  checkout() {
      this.app.router.navigate([AppConstants.RouteCheckout]);
  }

}

